import React from 'react';
import {NodeProps, useReactFlow} from 'reactflow';

import {RouterNodeAdapter} from 'processes/graph-builder-processes/processes-plugin/LogicNodeAdapters';
import {RouterNodeData} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorNodeTypes';
import {ReactFlowLockedContext} from 'ui-library/reactflow/LockedContext';
import {BenchlingNode} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNode';
import FlowchartNodeToolbar from 'ui-library/reactflow/nodes/toolbar/FlowchartNodeToolbar';

import createHeaderPropsForNode from './createHeaderPropsForNode';
import {getNodeAndRowStatusAndDescription} from './nodeUtils';

const routerNodeAdapter = new RouterNodeAdapter();

export default function RouterNodeRenderer(props: NodeProps<RouterNodeData>): JSX.Element {
  const {data, xPos, yPos, id} = props;
  const reactFlowInstance = useReactFlow();
  const isDeletable = routerNodeAdapter.isDeletable();
  const locked = ReactFlowLockedContext.useContext() ?? false;
  const {onNodeHeaderClick, onNodeDelete, isDisabled} = data;

  const finalHeaderProps = createHeaderPropsForNode(
    {
      ...data,
      position: {x: xPos, y: yPos},
    },
    reactFlowInstance
  );

  const {nodeStatus, nodeDescription} = getNodeAndRowStatusAndDescription(data.validationErrors);
  return (
    <div>
      <FlowchartNodeToolbar
        isLocked={locked || isDisabled}
        onNodeDelete={isDeletable ? onNodeDelete : undefined}
      />
      <div onClick={onNodeHeaderClick} style={{cursor: onNodeHeaderClick != null ? 'pointer' : 'default'}}>
        <BenchlingNode.Standard.Node
          isSelected={props.selected}
          isDisabled={isDisabled}
          status={nodeStatus}
          statusDescription={nodeDescription}
          headerProps={finalHeaderProps}
          width={data.nodeWidth}
          dataTestAttrs={{
            element: 'RouterNodeRenderer',
            key: id,
          }}
        />
      </div>
    </div>
  );
}
